<template>
<div class="pay-01">

    <ul class="w-100 nav nav-tabs nav-fill nav-payment-tab" id="myTab" role="tablist">
        <li class="nav-item">
            <a class="nav-link" :class="{'active' : this.currentTab == 'MORTGAGE'}" @click="selectTab('MORTGAGE')">
              <img class="mb-2 icon-56" :src="$util.asset('goobank_assets/assets/icons/home-icon@2x.png')" />
              บ้าน</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" :class="{'active' : this.currentTab == 'MONEY'}" @click="selectTab('MONEY')">
              <img class="mb-2 icon-56" :src="$util.asset('goobank_assets/assets/icons/contract-money@2x.png')" />
            เงินกู้</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" :class="{'active' : this.currentTab == 'THING'}" @click="selectTab('THING')">
              <img class="mb-2 icon-56" :src="$util.asset('goobank_assets/assets/icons/contract-thing@2x.png')" />
            สิ่งของ</a>
        </li>
    </ul>

    <SearchBar placeholder="ค้นหาสัญญา" v-model="contractSearchString"></SearchBar>
    <error-cant-reach-server :errorData="errorData"  class="mt-2 mr-2 ml-2" v-if="isCantReach" @clickCTA="$reloadPage()"></error-cant-reach-server>
    <div v-if="contractSearchString !== ''" class="container pl-4 pr-4 pt-1 pb-2 bg-white text-primary">
      พบ {{contracts.length}} สัญญา ที่มี "{{contractSearchString}}" ในประวัติสัญญา
    </div>
    <div class="list-group list-group-flush">
        <button v-for="contract in contracts" :key="contract.id" class="list-group-item list-group-item-action p-4" @click="navigate(contract)">
            <div class="row">
                <div class="col-8">
                    <p v-if="contract.type === 'MONEY'" class="m-0">สัญญากู้เงิน #{{contract.contractNo}}</p>
                    <p v-if="contract.type === 'THING'" class="m-0">สัญญาซื้อขาย #{{contract.contractNo}}</p>
                    <p v-if="contract.type === 'MORTGAGE'" class="m-0">สัญญาสินเชื่อบ้าน #{{contract.contractNo}}</p>
                    <p class="m-0 text-secondary">
                      <small>{{contract.info.moneyPayload.haigoo.name}}</small>
                    </p>
                </div>
                <div class="col-4 text-right">
                    <p class="m-0 text-primary">{{contract.info.moneyPayload.amount | money}}</p>
                    <p class="m-0 text-secondary"><small>ชำระทุกวันที่ {{ contract.payDate }}</small></p>
                </div>
            </div>

            <div class="row mt-2">
              <div class="col-6">
                <p v-if="contract.newPostponeStatus == 'DUE_TODAY'" class="m-0 text-secondary"><span class="badge badge-info">ครบกำหนดวันนี้</span></p>
                <p v-if="contract.newPostponeStatus == 'ON_DUE'" class="m-0 text-secondary"><span class="badge badge-info">ยังไม่ถึงกำหนดชำระ</span></p>
                <p v-if="contract.newPostponeStatus == 'OVER_DUE'" class="m-0 text-secondary"><span class="badge badge-danger">เกินกำหนด</span></p>
                <p v-if="contract.newPostponeStatus == 'ON_EXEMPT'" class="m-0 text-secondary"><span class="badge badge-info">อยู่ในช่วงผ่อนผัน</span></p>
              </div>
              <div class="col-6 text-right">
                <p class="m-0 text-secondary"><small>งวดที่ {{ contract.currentPeriod }}/{{ contract.allPeriod }} ประจำเดือน {{ contract.periodText }}</small></p>
              </div>
            </div>
        </button>
    </div>
    <div class="stick-down-pusher"></div>
    <div class="stick-down p-4"><a class="btn btn-light btn-lg btn-block" :href="$util.url('member/home')">ย้อนกลับ</a></div>
</div>
</template>

<script>
import SearchBar from '../../sub_components/SearchBar'

export default {
  data: () => ({
    isCantReach: false,
    errorData: {},
    contractSearchString: '',
    contracts: [],
    contractsAll: [],
    currentTab: 'MORTGAGE'
  }),
  async created () {
    await this.populateContracts();
    this.filterContrats();
  },
  watch: {
      contractSearchString () {
          this.filterContrats();
      },
      currentTab () {
          this.filterContrats();
      }
  },
  methods: {
    selectTab(tab) {
      this.currentTab = tab;
    },
    filterContrats() {
      const vm = this;
          if (this.contractSearchString === '') {
              this.contracts = this.contractsAll;
              this.contracts = this.contracts.filter(
                elm => (elm.type == this.currentTab)
              );
          } else {
              this.contracts = this.contractsAll.filter(function(elm) {
                if(elm.contractNo.toString().toLowerCase().includes(vm.contractSearchString.toLowerCase()) ||
                    elm.info.moneyPayload.haigoo.name.toLowerCase().includes(vm.contractSearchString.toLowerCase())
                    ) {
                      return elm;
                    } else {
                      return false;
                    }
                }
              );
              this.contracts = this.contracts.filter(
                elm => (elm.type == this.currentTab)
              );
          }
    },
    // Shamelessly copy methods from transaction-contract/List
    navigate (contract) {
      this.$router.push({ 
        name: 'pay-02', 
        params: { id: contract.id}, 
        query: { contractNo: contract.contractNo, type: contract.type}
      })
    },
    async populateContracts () {
      const result = await this.$api.contract.listForPay()
      const data = result.data
      if (!data.success) {
        this.isCantReach = true
        this.errorData = data
        return
      }
      this.contractsAll = this.contractFilter(data.contracts, 'KORGOO') // activeuser is korgoo
      this.contracts = this.contractsAll
    },
    contractFilter (contracts, activeUserSide) {
      return contracts.filter((elm) => {
        if (elm.activeUserSide === activeUserSide) return true
        return false
      })
    },
  },
  components: {
    SearchBar
  },
}
</script>

<style lang="scss">
</style>
